var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack20Px = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#757575",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.65179 6.64633C8.84706 6.45128 9.16362 6.45116 9.35882 6.64633C9.5537 6.84155 9.55379 7.15819 9.35882 7.35337L7.21722 9.49497H13.4975L13.5981 9.50473C13.8257 9.55149 13.9975 9.75347 13.9975 9.99497C13.9975 10.2364 13.8257 10.4385 13.5981 10.4852L13.4975 10.495H7.19769L9.35882 12.6561L9.4223 12.7352C9.5503 12.9292 9.52959 13.1933 9.35882 13.3641C9.18801 13.5348 8.92393 13.5556 8.72992 13.4276L8.65179 13.3631L5.64691 10.3582C5.49791 10.2091 5.46191 9.98901 5.54046 9.80649C5.57196 9.7291 5.62348 9.66257 5.68695 9.6102L8.65179 6.64633Z",
    fill: "currentColor",
    fillOpacity: 0.7
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack20Px);
export default ForwardRef;